import React from "react";
import { BASEURL } from "../../../utils/BaseUrl";
import axios from "axios";
import { useQuery } from "react-query";
import "./dashboard.css";

const DashboardLeadTabel = () => {
  const { data } = useQuery({
    queryKey: "getAllLead",
    queryFn: () =>
      axios.get(`${BASEURL}lead`).then((res) => {
        return res?.data;
      }),
  });

  return (
    <div className="table-container">
      <table className="custom-table">
        <thead>
          <tr>
            <th>S.no</th>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Message</th>
          </tr>
        </thead>
        <tbody>
          {data?.leads?.splice(0, 4)?.map((row, i) => (
            <tr key={i}>
              <td>{i + 1}</td>
              <td>{row.name}</td>
              <td>{row.email}</td>
              <td>{row.phone}</td>
              <td>{row.enquiry_message}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DashboardLeadTabel;
